module.exports = __webpack_public_path__ + "static/media/social_respon_cn2.21b1663d.png";